<template>
  <div class="invoice">
    <div class="invoice-heading">
      <h2>Payment Request</h2>
      <button @click="$router.push('/paymentrequests')">
        Manage{{ " " }}<i class="fa-solid fa-caret-right"></i>
      </button>
    </div>
    <div class="invoices">
      <!-- Single Invoice -->
      <div class="detail">
        <div class="icon-container fa-orange">
          <i class="fa-solid fa-arrow-up-long fa-icon "></i>
        </div>

        <div>
          <p>Sent</p>
          <div
            class="transaction-amount-loader-pr"
            v-if="!SentDisplay && SentDisplay !== 0"
          ></div>
          <span>{{ SentDisplay }}</span>
        </div>
      </div>
      <!-- Single Invoice -->
      <div class="detail">
        <div class="icon-container fa-blue">
          <i class="fa-solid fa-dollar-sign fa-icon e"></i>
        </div>

        <div>
          <p>Paid</p>
          <div
            class="transaction-amount-loader-pr"
            v-if="!PaidCountDisplay && PaidCountDisplay !== 0"
          ></div>
          <span>{{ PaidCountDisplay }}</span>
        </div>
      </div>
      <!-- Single Invoice -->
      <div class="detail">
        <div class="icon-container fa-purple">
          <i class="fa-solid fa-plus fa-icon "></i>
        </div>

        <div>
          <p>Created</p>
          <div
            class="transaction-amount-loader-pr"
            v-if="!CreatedDisplay && CreatedDisplay !== 0"
          ></div>
          <span>{{ CreatedDisplay }}</span>
        </div>
      </div>
      <!-- Single Invoice -->
      <div class="detail">
        <div class="icon-container fa-green">
          <i class="fa-solid fa-calculator fa-icon "></i>
        </div>

        <div>
          <p>Estimates</p>
          <div
            class="transaction-amount-loader-pr"
            v-if="!PaidAmountDisplay && PaidAmountDisplay !== 0"
          ></div>
          <span>{{ PaidAmountDisplay }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import dayjs from "dayjs";
import { getPaymentRequestTotals } from "../../../../graphql/queries";
export default {
  data() {
    return {
      startDate: dayjs().format("YYYY-MM"),
      endDate: dayjs().format("YYYY-MM-DD"),
      Sent: "Sent",
      Created: "Created",
      PaidAmount: "PaidAmount",
      PaidCount: "PaidCount",
      SentDisplay: null,
      CreatedDisplay: null,
      PaidAmountDisplay: null,
      PaidCountDisplay: null
    };
  },
  methods: {
    currencyFormatter(number) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      });

      return formatter.format(number);
    },
    async getSent() {
      const searchResponse = await API.graphql(
        graphqlOperation(getPaymentRequestTotals, {
          query: {
            startDate: this.startDate,
            endDate: this.endDate,
            databaseType: this.Sent
          }
        })
      );
      this.SentDisplay = searchResponse.data.getPaymentRequestTotals.Total;
    },
    async getCreated() {
      const searchResponse = await API.graphql(
        graphqlOperation(getPaymentRequestTotals, {
          query: {
            startDate: this.startDate,
            endDate: this.endDate,
            databaseType: this.Created
          }
        })
      );
      this.CreatedDisplay = searchResponse.data.getPaymentRequestTotals.Total;
    },
    async getPaidAmount() {
      const searchResponse = await API.graphql(
        graphqlOperation(getPaymentRequestTotals, {
          query: {
            startDate: this.startDate,
            endDate: this.endDate,
            databaseType: this.PaidAmount
          }
        })
      );
      this.PaidAmountDisplay = this.currencyFormatter(
        searchResponse.data.getPaymentRequestTotals.Total
      );
    },
    async getPaidCount() {
      const searchResponse = await API.graphql(
        graphqlOperation(getPaymentRequestTotals, {
          query: {
            startDate: this.startDate,
            endDate: this.endDate,
            databaseType: this.PaidCount
          }
        })
      );
      this.PaidCountDisplay = searchResponse.data.getPaymentRequestTotals.Total;
    }
  },
  async mounted() {
    await this.getSent();
    await this.getCreated();
    await this.getPaidAmount();
    await this.getPaidCount();
  }
};
</script>
